let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let SpeakerForm = require("../SpeakerForm");
let LinksForm = require("./LinksForm");
let QuestionnaireForm = require("./QuestionnaireForm");
let DisplayfieldsForm = require("./DisplayfieldsForm");
let LoadingWrap = require('ES/widgets/LoadingWrap');
let AuthedUserSession = require('../../../utils/AuthedUserSession');
let ProOnly = require('../../widgets/ProOnly');

let sids_I_can_manage = _.intersection(AuthedUserSession.getSIDsAtPackageLevel('PRO'), AuthedUserSession.doIHaveAccess.admin.getSIDs());

let getMySIDs = function (Displaylists) {
    let dl_sids = esUtils.cleanup_ids(_.map(Displaylists && Displaylists.perspeaker, "sid"));
    return _.uniq(_.intersection(dl_sids, sids_I_can_manage));
};

module.exports = dd.createClass({
    getInitialState() {
        return {selected_sid: -1};
    },
    componentWillReceiveProps(props) {
        this.__handleDefaultSIDfromProps(props);
    },
    componentDidMount() {
        this.__handleDefaultSIDfromProps(this.props);
    },
    __loadForSid: function (sid) {
        if (sid !== this.state.selected_sid) {
            this.setState({selected_sid: sid}, function () {
                var self = this;
                radio('read_ClientPortal_config').broadcast(sid,
                    function (sid, data) {
                        if (self.state.selected_sid == sid) {
                            self.setState({selected_sid: sid, data: data, error_msg: null, success_msg: null});
                        }
                    },
                    function (sid, message) {
                        if (self.state.selected_sid == sid) {
                            self.setState({error_msg: message, success_msg: null});
                        }
                    });
            });
        }
    },
    __handleDefaultSIDfromProps(props) {
        let {sid, Displaylists} = props;
        let my_sids = getMySIDs(Displaylists);
        let cur_sid = this.state.selected_sid;

        if (_.isEmpty(my_sids)) {
            return;
        }
        if (_.includes(my_sids, cur_sid)) {
            return;//no change needed
        }
        if (_.includes(my_sids, sid)) {
            this.__onSidChanged(sid);
            return;
        }
        sid = AuthedUserSession.getLastSelectedSID();
        sid = sid === 0 ? 1 : sid;//fix for Solution Tree to select master list
        if (_.includes(my_sids, sid)) {
            this.__onSidChanged(sid);
            return;
        }
        this.__onSidChanged(_.first(my_sids));
    },
    __onSidChanged(sid) {
        this.__loadForSid(_.parseInt(sid));
    },
    __onCancel: esUtils.wrapPreventDefault(function () {
        if (this.props.redir) {
            radio('Hashbang_set').broadcast(this.props.redir);
        }
    }),
    render: function () {
        let {redir, Displaylists} = this.props;
        let {selected_sid} = this.state;

        let onCancel = redir ? this.__onCancel : null;

        let my_sids = getMySIDs(Displaylists);

        let speaker;
        if (_.includes(my_sids, selected_sid)) {
            speaker = _.first(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
                return spkr.sid === selected_sid;
            }));
        }
        let data = _.get(this.state, "data", {});

        return LoadingWrap({is_loading: _.isEmpty(Displaylists), glass: true},
            dd.div({className: 'ClientPortalSettings'},
                dd.h2({style: {marginTop: 0}}, 'Client Portal settings'),
                dd.p({style: {marginBottom: 40}},
                    'Makes changes to the client portal settings for the selected speaker.',
                    " ",
                    dd.a({href: "https://www.espeakers.com/wiki/Client_Portal", target: "_blank"},
                        'More information',
                        dd.i({style: {marginLeft: "0.5em", fontSize: "1.0em"}, className: "fa fa-external-link"})
                    )
                ),
                ProOnly({
                        sids: AuthedUserSession.doIHaveAccess.admin.getSIDs(),
                        custom_message: 'Upgrade to PRO to use the amazing Client Portal to give your customers real-time access to some critical data about their event.'
                    },

                    _.size(my_sids) > 1 ? SpeakerForm({
                        sid: selected_sid,
                        Displaylists,
                        sids_to_choose: my_sids,
                        onSidChanged: this.__onSidChanged
                    }) : null,

                    dd.div({className: "clearfix"}),
                    speaker
                        ? dd.div({},
                        LinksForm({
                            speaker: speaker,
                            Displaylists: Displaylists,
                            config: data,
                        }),
                        QuestionnaireForm({
                            speaker: speaker,
                            Displaylists: Displaylists,
                            config: data
                        }),
                        DisplayfieldsForm({
                            speaker: speaker,
                            Displaylists: Displaylists,
                            config: data
                        })
                        )
                        : null
                ),
                onCancel ? dd.button({
                    className: 'btn btn-default btn-md',
                    onClick: onCancel
                }, 'Cancel') : null
            ),
            dd.div({className: "clearfix"})
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/ClientPortal/index.js